<template>
  <div class="fill-width d-flex align-center">
    <div class="flex-grow-1 d-flex flex-wrap mx-n1" style="padding-bottom: 2px;">
      <v-select
        v-bind="$attrs"
        class="mt-0 mx-1"
        style="width: 108px;"
        :items="MONTHS"
        :value="parts[1]"
        @input="x => emitParts([ parts[0], x, parts[2] ])"
      >
        <template v-slot:item="{ item }">
          {{item.text == 'Month' ? '' : item.text}}
        </template>
      </v-select>
      <v-select
        v-bind="$attrs"
        class="mt-0 flex-grow-0 mx-1"
        style="width: 78px;"
        :items="DAYS"
        :value="parts[2]"
        @input="x => emitParts([ parts[0], parts[1], x ])"
      >
        <template v-slot:item="{ item }">
          {{item.text == 'Day' ? '' : item}}
        </template>
      </v-select>
      <div class="flex-grow-0 relative mx-1">
        <div
          v-if="!year"
          class="absolute"
          v-bind:class="{
            'theme--light v-input--is-disabled': $attrs.hasOwnProperty('disabled') && ($attrs.disabled !== false)
          }"
          style="margin-top: 2px;"
        >
          Year
        </div>
        <v-text-field
          v-bind="$attrs" v-mask="'####'"
          class="mt-0"
          style="width: 48px;"
          type="tel"
          :rules="[ v => !v || /^\d\d\d\d$/.test(v || '') ]"
          v-model="year"
        />
      </div>
    </div>
    <div v-if="$slots['append-outer']" class="ml-2" style="margin-top: 2px;">
      <slot name="append-outer"></slot>
    </div>
  </div>
</template>

<script>
import { LOCALE } from '@/utils/intl.js';


const MONTHS = [
  { value: '00', text: 'Month' },
  ...Array.from(Array(12).keys()).map(
    x => ({
      value: String(x + 1).padStart(2, '0'),
      text: (new Date(2000, x)).toLocaleString(LOCALE, { month: 'long' })
    })
  )
];


const DAYS = [ { value: '00', text: 'Day' }, ...Array.from(Array(31).keys()).map(x => String(x + 1).padStart(2, '0')) ];


export default {
  name: 'contact-field-date',

  props: [ 'value' ],

  data() {
    return {
      year: ''
    };
  },

  computed: {
    parts() {
      return /^\d\d\d\d-\d\d-\d\d$/.test(this.value || '') ? this.value.split('-') : [ '0000', '00', '00' ];
    }
  },

  created() {
    Object.assign(this, { MONTHS, DAYS });
  },

  methods: {
    emitParts(parts) {
      const value = parts.join('-');
      this.$emit('input', value == '0000-00-00' ? '' : value);
    }
  },

  watch: {
    parts: {
      immediate: true,
      handler(v) {
        this.year = v[0] == '0000' ? '' : v[0];
      }
    },

    year(v) {
      if (/^\d\d\d\d$/.test(v || ''))
        this.emitParts([ v, this.parts[1], this.parts[2] ]);
    }
  }
}
</script>
